import getApiUrl from "../../services/getApiUrl";

/**
 * Pesquisa por automações
 * @returns
 * @param data
 */
export const getAutomations = async (data = {}) => {
    return await getApiUrl.get(`/automations`, {
        params:data
    })
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            return err;
        });
};

export const createAutomation = async (data = {}) => {
    return await getApiUrl.post(`/automations`, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            return err;
        });
};

export const getConfigAlertsAutomation = async (id) => {
    return await getApiUrl
        .get(`/automations/${id}/config-alerts`)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            return err;
        });
};

export const getAutomationsHealth = async (data = {}) => {
    try {
        const response = await getApiUrl.get(`/automations/health`, {
            params: data,
        });
        return response.data;
    } catch (err) {
        console.error('Erro ao buscar automações com saúde:', err);
        return { total: 0, data: [] };
    }
};

export const getAlertsByUnit = async (unitId) => {
    return await getApiUrl
        .get(`/automations-alerts/unit/${unitId}`)
        .then((res) => res.data)
        .catch((err) => err);
};

export const addUsersToAlerts = async ({ unitId, channel, users }) => {
    return await getApiUrl
        .post(`/automations-alerts/users`, { unitId, channel, users })
        .then((res) => res.data)
        .catch((err) => err);
};

export const removeUserFromAlerts = async ({ unitId, channel, userId }) => {
    return await getApiUrl
        .delete(`/automations-alerts/users`, { data: { unitId, channel, userId } })
        .then((res) => res.data ?? true)
        .catch((err) => err);
};

export const updateAlertsLevel = async ({ unitId, channel, level }) => {
    return await getApiUrl
        .patch(`/automations-alerts/level`, { unitId, channel, level })
        .then((res) => res.data)
        .catch((err) => err);
};
